import React, {useContext} from 'react';
import {Button, Descriptions, Space} from 'antd';
import {CardStyled} from "../../../components/styled/card.styled";
import {useLoaderData, useNavigate} from "react-router-dom";
import {ButtonBar} from "../../../builder";
import {Translate} from "../../../components/util/translation.util";
import {TranslationDomainEnum} from "../../../types/enums";
import {MyAccountViewResponse} from "../../../types/modules/user/response";
import {Helmet} from 'react-helmet-async';
import {StoreContext} from '../../../store.context';

export const MyAccount: React.FC = () => {
    const translationDomain = TranslationDomainEnum.USER_ADMINISTRATION;
    const data: MyAccountViewResponse = useLoaderData() as MyAccountViewResponse;
    const navigate = useNavigate();
    const {appStore: {translate}} = useContext(StoreContext);
    const title = translate('user.title.my_account', {}, translationDomain);

    return (
            <>
                <Helmet>
                    <title>{`CL BO - ${title}`}</title>
                </Helmet>
                <Space direction="vertical" size="small" style={{display: 'flex'}}>
                    <CardStyled title={`View`}>
                        <div style={{padding: '16px', paddingBottom: 0}}>
                            <Space direction={`vertical`} style={{display: 'flex'}}>
                                <Descriptions bordered>
                                    <Descriptions.Item label={<Translate message={`user.field.username`} domain={translationDomain}/>} span={3}>{data.username}</Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`user.field.firstName`} domain={translationDomain}/>} span={3}>{data.firstName}</Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`user.field.lastName`} domain={translationDomain}/>} span={3}>{data.lastName}</Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`user.field.initials`} domain={translationDomain}/>} span={3}>{data.initials}</Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`user.field.additions`} domain={translationDomain}/>} span={3}>{data.additions}</Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`user.field.email`} domain={translationDomain}/>} span={3}>{data.email}</Descriptions.Item>
                                </Descriptions>
                            </Space>
                        </div>
                    </CardStyled>

                    <ButtonBar>
                        <Button type={`primary`} onClick={() => navigate(`/my_account/edit`)}>
                            <Translate message={`global.button.edit`}/>
                        </Button>
                        <Button type="primary" className={`ant-btn-secondary`} onClick={() => navigate(`/my_account/password/edit`)}>
                            <Translate message={`user.button.change_password`} domain={translationDomain}/>
                        </Button>
                    </ButtonBar>
                </Space>
            </>

    )
}